module.exports = __webpack_public_path__ + "img/ic-exclamation-yellow.f8c8b057.svg";